export default __webpack_public_path__ + "static/media/simple-onboarding.a16fe759.png";